import _ from 'underscore';
import React from 'react';
import moment from 'moment';
import { LimitedDateRangePicker } from './limited_date_range_picker';

export class LimitedDateRangePickerContainer extends React.Component {
  getStateFromStore = () => {
    return {
      displayedDates:
        Aedu.ReduxStore.getState().AnalyticsDashboard.DisplayedDates,
    };
  };

  componentDidMount() {
    this.unsubscribe = Aedu.ReduxStore.subscribe(
      function () {
        this.setState(this.getStateFromStore());
      }.bind(this),
    );
  }

  urlForParams = (params) => {
    const urlWithoutQueryParams =
      location.origin + location.pathname + location.hash;
    return window.$a.build_url(urlWithoutQueryParams, _.pairs(params));
  };

  click30Day = () => {
    window.location = this.urlForParams({
      start: moment().subtract(30, 'day').format(),
      finish: moment().format(),
    });
  };

  click60Day = () => {
    window.location = this.urlForParams({
      start: moment().subtract(60, 'day').format(),
      finish: moment().format(),
    });
  };

  state = this.getStateFromStore();

  render() {
    return (
      <LimitedDateRangePicker
        displayedDates={this.state.displayedDates}
        click30Day={this.click30Day}
        click60Day={this.click60Day}
      />
    );
  }
}
